<template>
	<div>
		<div class="-wrapper">
			<div class="-wrapper v-center-" style="width: 100%">
				<div class="-search-bar" style="width: 100%">
					<span class="-search-icon">
						<span class="material-icons">search</span>
					</span>
					<input type="search" v-model="srchText" @keyup="callSetSearchKey(srchText)" style="width: 100%" class="-search" :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH_TEXT')">
					<button type="button" class="-btn borderless- small- icon-only-" :class="srchText == '' ? 'close-' : ''" @click="srchText = '';callSetSearchKey()">
						<span class="material-icons">close</span>
					</button>
				</div>
			</div>
		</div>
		<div>
			<div-loading v-if="isSideLoading" :full="false"></div-loading>
			<table v-else class="tbl-default resource-table" data-linkable-row>
				<caption></caption>
				<colgroup>
					<col style="width: 520px">
					<col>
				</colgroup>
				<thead>
				<tr>
					<th scope="col" class="md1">
						<div>
							<span class="mr-1">
								<input ref="checkAll" type="checkbox" id="check-all" class="checkbox txt-none" v-model="isCheckAll">
								<label for="check-all"></label>
							</span>
							<span>{{ $t('AUDIT.WHITELIST.HEADER.CLOUD_SERVICE') }}</span>
						</div>
					</th>
					<th scope="col" class="md2">
						<button type="button" class="buttons-tbl-header"
							:data-type="sortColumn !== 'accId' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
							@click="setSortColumn('accId')">{{ $t('AUDIT.WHITELIST.HEADER.ACCOUNT') }}<!--규칙 이름-->
						</button>
					</th>
					<th scope="col" class="md1">
						<button type="button" class="buttons-tbl-header"
							:data-type="sortColumn !== 'rsrcType' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
							@click="setSortColumn('rsrcType')">{{ $t('AUDIT.WHITELIST.HEADER.PRODUCT') }}<!--규칙 이름-->
						</button>
					</th>
					<th scope="col" class="md1">
						<button type="button" class="buttons-tbl-header"
							:data-type="sortColumn !== 'rgnId' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
							@click="setSortColumn('rgnId')">{{ $t('AUDIT.WHITELIST.HEADER.REGION') }}<!--규칙 이름-->
						</button>
					</th>
					<th scope="col" class="md2">
						<button type="button" class="buttons-tbl-header"
							:data-type="sortColumn !== 'instId' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
							@click="setSortColumn('instId')">{{ $t('AUDIT.WHITELIST.HEADER.RESOURCE_ID') }}<!--규칙 이름-->
						</button>
					</th>
				</tr>
				</thead>
				<tbody v-if="resourceList.length > 0">
					<tr v-for="(item, idx) of resourceList" :key="idx">
						<td class="align-center">
							<span class="mr-4">
								<input
									type="checkbox"
									class="checkbox txt-none"
									v-model="checkedItems"
									:value="item.instId"
									:id="item.instId"
								>
								<label :for="item.instId">{{checked}}</label>
							</span>
							<span class="rule-name-category">
								<span class="icon-vender txt-none"
									data-size="m"
									:data-vendor="Common.getVendorByKey(item.vndr)"
									:title="Common.getVendorByKey(item.vndr)">{{Common.getVendorByKey(item.vndr)}}
								</span>
							</span>
						</td>
						<td class="break-word">
							<span>{{`${item.accId} (${item.accAlias})`}}</span>
						</td>
						<td class="break-word">
							<span>{{getProdName(item.rsrcType)}}</span>
						</td>
						<td class="break-word">
							<span>{{getRgnName(item.rgnId)}}</span>
						</td>
						<td class="break-word">
							<span>{{item.instId}}</span>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<td colspan="5" style="text-align: center;padding: 40px;">
						<p class='overlay-nodata'><span>{{$t('COMMON.NO_DATA')}}</span></p>
					</td>
				</tbody>
			</table>
			<div-loading v-if="isLoading"/>
			<Pagination v-if="resourceList.length != 0"
				:callSetCurPage="callSetCurPage"
				:callSetRowsPerPage="callSetRowsPerPage"
				:currentPage="paging.currentPage"
				:rowsPerPage="paging.rowPerPage"
				:totalPage="paging.totalPage"
			/>
		</div>
	</div>
</template>
<script>
import Pagination from "../../common/Pagination.vue";
export default {
	name: "ResourceTable",
	components: {Pagination},
	data() {
		return {
			checked: true,
			sortColumn: '',
			sortOrder: '',
			checkedItems: [],
			srchText: "",
			listSelectedPolicy: [],
			isCheckAll: false,
			listItemValue: [],
			listSelectedRule: [],
			isLoading: false,
			plcyList: [],
		}
	},
	props: {
		preSortObject: {
			type: Object,
			default: ()=>{}
		},
		callSetSortKey: {
			type: Function,
			default: ()=>{}
		},
		callSetSearchKey: {
			type: Function,
			default: ()=>{}
		},
		preSelectedItems: {
			type: Object,
			default: ()=>[]
		},
		paging: {
			type: Object,
			defaults: ()=>{},
		},
		callSetRowsPerPage: {
			type: Function,
			default: ()=>{}
		},
		callSetCurPage: {
			type: Function,
			default: ()=>{}
		},
		resourceList: {
			type: Array,
			default: ()=>[]
		},
		isSideLoading : {
			type: Boolean,
			default: ()=> true
		}
	},
	mounted() {
		const selectedItem =  this.preSelectedItems[this.paging.currentPage];
		if (selectedItem) {
			this.checkedItems = _.cloneDeep(selectedItem);
		}
		if (this.preSortObject) {
			this.sortColumn = this.preSortObject.sortColumn;
			this.sortOrder = this.preSortObject.sortOrder;
			console.log("preSortObject ", this.preSortObject);
		}
	},
	watch: {
		isCheckAll(isAll) {
			console.log("isCheckALl: ", isAll);
			if (isAll) {
				this.checkedItems = this.resourceList.map(rsrc=>{return rsrc.instId});
			} else {
				this.checkedItems = [];
			}
		},
		checkedItems(newVal) {
			this.$emit('onChecked', {selectedItems: newVal});
			if (newVal.length === this.resourceList.length) {
				this.isCheckAll = true;
			} else {
				this.isCheckAll = false;
			}
		},
	},
	methods: {
		fnSearching() {
			console.log("set search key");
		},
		onCheckAll() {
			console.log("Check all");
		},
		getProdName(prodId) {
			if (this.$te('PRODUCT.' + prodId)) {
                return this.$t('PRODUCT.' + prodId);
            }
            return prodId;
		},
		getRgnName(rgn) {
            if (this.$te('COMMON.REGION.' + rgn)) {
                return this.$t('COMMON.REGION.' + rgn);
            }
            return rgn;
        },
		setSortColumn(targetColumn) {
			const sortObject = this.Common.setSortColumn(this.sortColumn, this.sortOrder, targetColumn);
			this.sortColumn = sortObject.sortColumn;
			this.sortOrder = sortObject.sortOrder;
			this.callSetSortKey(sortObject);
		},
	}
}
</script>


<style scoped lang="scss">
/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body {
	overflow-x: hidden;
	overflow-y: auto;
}

/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body::-webkit-scrollbar
{
	width: 8px;
	background-color: #F5F5F5;
}

/deep/ .ag-body-viewport.ag-layout-normal.ag-row-no-animation.ag-body::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #989fa9;
}
/deep/ .ag-body-horizontal-scroll-viewport {
	overflow-x: hidden;
}
/deep/ .ag-header-viewport {
    background-color: #f6f8fa;
    color: #6e6e6e;
}
/deep/ .ag-header-cell-label {
    border-right-width: 1px;
    border-right-style: solid;
    margin-right: 10px;
    border-right-color: gray;
}
.custom-pagination.-pagination {
	position: inherit;
	padding: 10px;
}
span.rule-title {
	display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: calc(100% - 20px);
	width: 500px;
}
.rule-description {
	display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
	width: 550px;
}
.description {
	border-left: none;
}
.float-left {
	float: left;
}
.align-center {
	text-align: center;
}
.table-rule {
	height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
}

.resource-table>thead>tr th.md1 {
	width: 10%;
}
.resource-table>thead>tr th.md2 {
	width: 20%;
}
.break-word {
	word-break: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/settingComponents/ResourceTable.vue